// App.js
import React from 'react';

import './App.css'; // Import the CSS file
import { RoutesComp } from './Routescomp';

function App() {
  return (
    <RoutesComp/>
  );
}

export default App;
